<template>
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 56 56" fill="currentColor"><path d="m47.7 7-7.8 11.7 7.8 11.7h-36v21H9.4V4.7h2.3V7h36Zm-4.4 2.3H11.7V28h31.7l-6.2-9.3 6.2-9.3Z"/></svg>
</template>

